import { type FC } from 'react'

import { useGlobalConfigContext } from '../../../global-config'
import { FooterTrusted } from '../../../standard-shop-layout'
import { TENANT } from '../../../tenant'
import { getRegisterBoxConfigByTenant } from '../../registrationBoxConfig'
import { LoginRegistrationSiqtLogo } from '../LoginRegistrationSiqtLogo/LoginRegistrationSiqtLogo'
import { LoginRegistrationUniqueSellingPoints } from '../LoginRegistrationUniqueSellingPoints/LoginRegistrationUniqueSellingPoints'

export const LoginRegistrationRegistrationBoxFooter: FC = () => {
  const { language, tenant } = useGlobalConfigContext()
  const registrationConfig = getRegisterBoxConfigByTenant(tenant)
  let trustLogos = registrationConfig?.logos[language]

  if (tenant === TENANT.AT) {
    trustLogos = trustLogos?.filter((item) => item.id === 'tuv')
  }

  return (
    <div>
      <div className="flex">
        <div className="flex-1">
          <LoginRegistrationUniqueSellingPoints
            uniqueSellingPoints={registrationConfig?.uniqueSellingPoints}
          />
        </div>
        {trustLogos ? (
          <div>
            <FooterTrusted
              className="hidden !py-0 tablet:block"
              trustedItems={trustLogos}
            />
          </div>
        ) : null}
      </div>
      <LoginRegistrationSiqtLogo className="mb-2 mt-6 hidden tablet:block" />
    </div>
  )
}
